<template>
  <div class="body">
    <elinknav class="nav"></elinknav>
    <div class="books">
      <loading :active.sync="loading" loader="bars" color="#00ab00"></loading>
      <template v-for="book in books">
        <router-link :key="book.isbn" :to="`/book/${book.isbn}`">
          <div class="card">
            <image-loader class="cover" :src="book.coverPath" />
            <div class="bottombar">
              <span class="title">{{ book.cnTitle }}</span>
            </div>
          </div>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import Nav from "./Nav";
import { get } from "../../libs/bookRequest";
import { bookAPI } from "../../libs/consts";
import * as utils from "../../libs/utils";
export default {
  components: {
    elinknav: Nav,
  },
  data() {
    return {
      books: [],
      hasmore: true,
      loading: false,
      pgInd: 1,
      pgLen: 10,
    };
  },
  computed: {
    category() {
      return this.$route.query.c;
    },
  },
  created() {
    this.loadData();
    window.addEventListener("scroll", this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll);
  },
  methods: {
    scroll() {
      //window 1%的误差
      if (
        utils.scrollFix(utils.getScrollHeight()) ==
        utils.scrollFix(utils.getWindowHeight() + utils.getDocumentTop())
      ) {
        this.loadData();
      }
    },
    loadData() {
      if (!this.hasmore || this.loading) return;
      this.loading = true;
      get(bookAPI.book.books, {
        PageIndex: this.pgInd,
        PageSize: this.pgLen,
        CategoryName: this.category,
      })
        .then((rps) => {
          const result = rps.items;
          this.books.push(...result);
          if (rps.total / this.pgLen > this.pgInd) {
            this.pgInd += 1;
          } else {
            this.hasmore = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    category() {
      this.pgInd = 1;
      this.hasmore = true;
      this.books = [];
      this.loadData();
    },
  },
};
</script>

<style scoped>
.body {
  display: flex;
  margin: 1.64rem 0;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.content {
  height: 100%;
  width: 5.4rem;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex-wrap: wrap;
}
.nav {
  width: 3.5rem;
  position: fixed;
}
.books {
  width: calc(100vw - 3.5rem);
  display: flex;
  position: relative;
  align-items: center;
  align-self: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 3.5rem;
}

.card {
  width: 3.2rem;
  height: 4.8rem;
  margin: 0 0.3rem 0.25rem;
}

.cover {
  width: 3.2rem;
  height: 4.4rem;
  box-shadow: 0px 0px 10px 0px rgba(132, 132, 132, 0.5);
}

.cover img {
  width: 100%;
  height: 100%;
}

.bottombar {
  display: flex;
  position: relative;
  align-items: center;
  align-self: center;
  flex-direction: row;
  height: 0.22rem;
  /* margin-top: 0.12rem; */
  justify-content: space-between;
  padding: 0.15rem 0 0.17rem;
}

.title {
  text-decoration: none;
  line-height: 0.22rem;
  letter-spacing: 0px;
  white-space: nowrap;
  color: #474747;
  font-size: 0.2rem;
  align-self: baseline;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>